import React from 'react';
import { useState, useEffect } from 'react';
import {
    Card,
    FormLayout,
    TextField,
    Stack,
} from '@shopify/polaris';
import { GenieTag } from "../../../../components/GenieTag";

export function TagProductsOnCreationSettings(props) {

    const [currentTag, setCurrentTag] = useState("");

    const updateTags = (newTags) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tags = newTags;
        props.onSettingsChange(newSettings);
    }

    const onTagClick = (tagName) => {

        var selectedIndex = props.settings.tags.findIndex(_ => _ === tagName);
        var newTags = [
            ...props.settings.tags.slice(0, selectedIndex),
            ...props.settings.tags.slice(selectedIndex + 1)
        ];

        updateTags(newTags);
    }

    const onKeyDown = (event) => {

        if (event.code === 'Enter' && event.target != null && event.target.name === "tagInputField") {

            if (currentTag != null && currentTag !== "") {
                setCurrentTag("");
                updateTags([...props.settings.tags, currentTag]);
            }
        }
    }

    useEffect(() => {

        window.document.addEventListener('keydown', onKeyDown, {
            capture: false,
            once: false,
            useCapture: false,
            passive: true,
        });

        return () => {
            window.document.removeEventListener('keydown', onKeyDown, {
                capture: false,
                once: false,
                useCapture: false,
                passive: true,
            });
        };

    });

    var tags = props.settings.tags.map(_ => <GenieTag id={_} onClick={onTagClick}>{_}</GenieTag>)

    return (
        <React.Fragment>
            <Card.Section title="Choose tags">
                <FormLayout>
                    <TextField
                        value={currentTag}
                        name="tagInputField"
                        placeholder="Enter tag name and press enter. Click on tags to remove."
                        onChange={value => setCurrentTag(value)}
                        helpText={
                            <span>
                                Choose tags to be added when a product is created.
                            </span>
                        }
                    />
                </FormLayout>
                <br />
                <Stack>
                    {tags}
                </Stack>
            </Card.Section>
        </React.Fragment>
    );
}